/* ============================================
   ET - Video (PDP_004)
   Gallery video trigger + full-screen popup behavior.
   Safe no-op while the feature is hidden (control group).
   ============================================ */
(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.etVideoInit === '1') return;
    root.dataset.etVideoInit = '1';

    var trigger = root.querySelector('[data-et-video-trigger]');
    var popup = root.querySelector('[data-et-video-popup]');
    if (!trigger || !popup) return;

    var player = popup.querySelector('[data-et-video-player]');
    var video = popup.querySelector('video');
    var closeBtn = popup.querySelector('[data-et-video-close]');
    var prevOverflow = '';

    function isOpen() {
      return popup.classList.contains('is-open');
    }

    function playVideo() {
      if (!video) return;
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {
          video.muted = true;
          var retry = video.play();
          if (retry && typeof retry.catch === 'function') retry.catch(function () {});
        });
      }
    }

    function open() {
      if (isOpen()) return;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      if (video) {
        try {
          video.currentTime = 0;
        } catch (e) {
          /* metadata not loaded yet; play() starts from 0 anyway */
        }
        playVideo();
      }
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen()) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = prevOverflow;
      if (video) video.pause();
      trigger.focus();
    }

    // Move the trigger into the first gallery cell so it sits exactly on the
    // first slide (and travels with it), on every media layout. Falls back to
    // wrapper-relative positioning when no cell exists.
    var wrapper = root.closest('.f-product__media-wrapper') || document;
    var firstCell = wrapper.querySelector('.f-product__media');
    if (firstCell) {
      firstCell.appendChild(trigger);
      trigger.classList.add('et-video__trigger--in-cell');
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      open();
    });

    // Delegated popup clicks: close button, backdrop (anything outside the
    // player), and play/pause toggle on the video itself.
    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-et-video-close]')) {
        close();
        return;
      }
      if (video && event.target === video) {
        if (video.paused) {
          playVideo();
        } else {
          video.pause();
        }
        return;
      }
      if (!player || !player.contains(event.target)) {
        close();
      }
    });

    function onKeydown(event) {
      if (event.key === 'Escape' && isOpen()) close();
    }
    document.addEventListener('keydown', onKeydown);

    // Theme-editor re-renders replace the DOM: unlock scroll and drop the
    // document listener so nothing leaks between renders.
    root.etVideoDestroy = function () {
      if (isOpen()) close();
      document.removeEventListener('keydown', onKeydown);
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-et-video]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-et-video]').forEach(function (root) {
      if (typeof root.etVideoDestroy === 'function') root.etVideoDestroy();
    });
  });
})();
